import React, {ReactNode} from "react";
import {HintProps} from "./Hint.types";


class Hint extends React.Component<HintProps, {}> {


    constructor(props: Readonly<HintProps>) {
        super(props);
    }


    public render(): ReactNode {
        return (
            <div
                style={{
                    ...{fontStyle: "italic", color: (this.props.isError ? "#D42928" : "#888888")},
                    ...this.props.style
                }}>
                {this.props.href && (
                    <a href={this.props.href}
                       style={{color: "#417CAF", textDecoration: "none"}}
                       target={this.props.target ? this.props.target : "_blank"}>
                        {this.props.text}
                    </a>
                )}
                {!this.props.href && (
                    this.props.text
                )}
            </div>
        );
    }

}


export default Hint;
